<template>
  <v-container v-if="localita && previsione" class="min-w-1000px">

    <v-row class="bg-grey-lighten-5">
      <v-col></v-col>
      <v-col class="text-body-2 text-center bg-blue-lighten-4">{{ $t('home.previsioni.esaSlot.night') }}</v-col>
      <v-col class="text-body-2 text-center bg-blue-lighten-4">{{ $t('home.previsioni.esaSlot.morning') }}</v-col>
      <v-col class="text-body-2 text-center bg-blue-lighten-4">{{ $t('home.previsioni.esaSlot.afternoon') }}</v-col>
      <v-col class="text-body-2 text-center bg-blue-lighten-4">{{ $t('home.previsioni.esaSlot.evening') }}</v-col>
    </v-row>

    <v-row class="bg-grey-lighten-5">
      <v-col class="my-auto">
        <v-container class="w-66 pa-0 bg-grey-lighten-3">
          <v-container class="text-body-1 font-weight-medium text-center bg-blue-lighten-4 pa-2">{{ $t(`home.previsioni.dayByIndex.${ getDayIndex(previsione.data) }`) }}</v-container>
          <v-container class="text-caption text-center pa-2 pb-0">{{ $t( `home.previsioni.dayOfTheWeek.${ getDayOfTheWeek(previsione.data) }` ) }}</v-container>
          <v-container class="text-h3 text-center font-weight-bold pa-2 pb-0">{{ getDay(previsione.data) }}</v-container>
          <v-container class="text-subtitle-2 font-weight-medium text-center pa-2">{{ $t( `home.previsioni.month.${ getMonth(previsione.data) }` ) }}</v-container>
        </v-container>
      </v-col>
      <v-col class="my-auto">
        <v-img class="mb-3" height="75px" :src="getSimboloUrl(previsione.previsione_esaoraria[0])" />
        <v-container class="pa-0 text-h4 font-weight-bold text-center">{{ previsione.previsione_esaoraria[0].temperatura.gradi }}°</v-container>
      </v-col>
      <v-col class="my-auto">
        <v-img class="mb-3" height="75px" :src="getSimboloUrl(previsione.previsione_esaoraria[1])" />
        <v-container class="pa-0 text-h4 font-weight-bold text-center">{{ previsione.previsione_esaoraria[1].temperatura.gradi }}°</v-container>
      </v-col>
      <v-col class="my-auto">
        <v-img class="mb-3" height="75px" :src="getSimboloUrl(previsione.previsione_esaoraria[2])" />
        <v-container class="pa-0 text-h4 font-weight-bold text-center">{{ previsione.previsione_esaoraria[2].temperatura.gradi }}°</v-container>
      </v-col>
      <v-col class="my-auto">
        <v-img class="mb-3" height="75px" :src="getSimboloUrl(previsione.previsione_esaoraria[3])" />
        <v-container class="pa-0 text-h4 font-weight-bold text-center">{{ previsione.previsione_esaoraria[3].temperatura.gradi }}°</v-container>
      </v-col>
    </v-row>

    <v-row v-if="localita.showData && localita.showData.precipitazioni" class="py-2">
      <v-col class="text-body-2 text-center">{{ $t('home.previsioni.rows.precipitazioni') }}</v-col>
      <v-col class="text-body-2 text-center">{{ getPrecipitazioneValue(previsione.previsione_esaoraria[0]) }}</v-col>
      <v-col class="text-body-2 text-center">{{ getPrecipitazioneValue(previsione.previsione_esaoraria[1]) }}</v-col>
      <v-col class="text-body-2 text-center">{{ getPrecipitazioneValue(previsione.previsione_esaoraria[2]) }}</v-col>
      <v-col class="text-body-2 text-center">{{ getPrecipitazioneValue(previsione.previsione_esaoraria[3]) }}</v-col>
    </v-row>
    <v-divider v-if="localita.showData && localita.showData.precipitazioni" thickness="1" />

    <v-row v-if="localita.showData && localita.showData.umidita" class="py-2">
      <v-col class="text-body-2 text-center">{{ $t('home.previsioni.rows.umidita') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[0].hr }}{{ $t('home.previsioni.units.umidita') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[1].hr }}{{ $t('home.previsioni.units.umidita') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[2].hr }}{{ $t('home.previsioni.units.umidita') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[3].hr }}{{ $t('home.previsioni.units.umidita') }}</v-col>
    </v-row>
    <v-divider v-if="localita.showData && localita.showData.umidita" thickness="1" />

    <v-row v-if="localita.showData && localita.showData.zero_termico" class="py-2">
      <v-col class="text-body-2 text-center">{{ $t('home.previsioni.rows.zeroTermico') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[0].zt }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[1].zt }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[2].zt }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[3].zt }}</v-col>
    </v-row>
    <v-divider v-if="localita.showData && localita.showData.zero_termico" thickness="1" />

    <v-row v-if="localita.showData && localita.showData.quota_neve" class="py-2">
      <v-col class="text-body-2 text-center">{{ $t('home.previsioni.rows.quotaNeve') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[0].qn }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[1].qn }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[2].qn }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[3].qn }}</v-col>
    </v-row>
    <v-divider v-if="localita.showData && localita.showData.quota_neve" thickness="1" />

    <v-row v-if="localita.showData && localita.showData.vento_medio" class="py-2">
      <v-col class="text-body-2 text-center">{{ $t('home.previsioni.rows.ventoMedio') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[0].vento.intensita }} {{ $t('home.previsioni.units.vento') }} {{ previsione.previsione_esaoraria[0].vento.direzione }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[1].vento.intensita }} {{ $t('home.previsioni.units.vento') }} {{ previsione.previsione_esaoraria[1].vento.direzione }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[2].vento.intensita }} {{ $t('home.previsioni.units.vento') }} {{ previsione.previsione_esaoraria[2].vento.direzione }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[3].vento.intensita }} {{ $t('home.previsioni.units.vento') }} {{ previsione.previsione_esaoraria[3].vento.direzione }}</v-col>
    </v-row>
    <v-divider v-if="localita.showData && localita.showData.vento_medio" thickness="1" />

    <v-row v-if="localita.showData && localita.showData.raffica" class="py-2">
      <v-col class="text-body-2 text-center">{{ $t('home.previsioni.rows.raffica') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[0].raffica }} {{ $t('home.previsioni.units.vento') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[1].raffica }} {{ $t('home.previsioni.units.vento') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[2].raffica }} {{ $t('home.previsioni.units.vento') }}</v-col>
      <v-col class="text-body-2 text-center">{{ previsione.previsione_esaoraria[3].raffica }} {{ $t('home.previsioni.units.vento') }}</v-col>
    </v-row>
    <v-divider v-if="localita.showData && localita.showData.raffica"thickness="1" />

  </v-container>
</template>


<script lang="ts">
import { PrevisioneEsaoraria, PrevisioneGiorno } from '@/modules/api';
import { LocalitaTab } from '@/modules/localitaTab';
import { getDayIndexFromDate } from '@/utils/utils';
import { defineComponent } from 'vue';


export default defineComponent({
  name: "PrevisioneTable",
  props: {
    "localita": {
      type: Object as () => LocalitaTab
    },
    "previsione": {
      type: Object as () => PrevisioneGiorno
    },
  },
  data() {
    return {}
  },
  methods: {
    getDayIndex(dataAsString: string): number {
      const data = new Date(dataAsString);
      return getDayIndexFromDate(data);
    },
    getSimboloUrl(previsione_esaoraria: PrevisioneEsaoraria): string {
      return `https://www.3bmeteo.com/images/set_icone/3/new/${ previsione_esaoraria.id_simbolo_maso }${ previsione_esaoraria.notte == 1 ? 'n' : '' }.png`
    },
    getDayOfTheWeek(dataAsString: string): number {
      const data: Date = new Date(dataAsString);
      return data.getDay();
    },
    getDay(dataAsString: string): number {
      const data: Date = new Date(dataAsString);
      return data.getDate();
    },
    getMonth(dataAsString: string): number {
      const data: Date = new Date(dataAsString);
      return data.getMonth();
    },
    getPrecipitazioneValue(previsioneEsa: PrevisioneEsaoraria): string {
      if (previsioneEsa.precipitazioni == 0) {
        return this.$t('home.previsioni.values.assenti')
      }
      return `${ previsioneEsa.precipitazioni } ${ previsioneEsa.prec_unita }`;
    }
  },
  created() {
  },
})

</script>